export default {
  'device.name': 'Device management',
  'device.deviceName': 'Device name',
  'device.deviceCode': 'Device code',
  'device.deviceCapacity': 'Power equipment',
  'device.deviceLong': 'Longitude',
  'device.deviceLat': 'Latitude',
  'device.isActive': 'Operating status',
  'device.devicePassword': 'Password',
  'device.create': 'Add equipment',
  'device.update': 'Device update',
  'device.information': 'Device Information',
  'device.delete.title': 'Delete the device',
  'device.content.delete':
    'You are sure to delete the device.The erased device will not help but admire',
  'device.deviceType': 'Device type',
  'device.delete': 'Delete device',
  'device.action': 'Action',
};
